import {
  LIST_REGIONAL_REQUEST,
  LIST_REGIONAL_SUCCESS,
  LIST_REGIONAL_FAILURE,
  LIST_REGIONAL_SUMMARY_REQUEST,
  LIST_REGIONAL_SUMMARY_SUCCESS,
  LIST_REGIONAL_SUMMARY_FAILURE,
  CREATE_REGIONAL_REQUEST,
  CREATE_REGIONAL_SUCCESS,
  CREATE_REGIONAL_FAILURE,
  DETAIL_REGIONAL_REQUEST,
  DETAIL_REGIONAL_SUCCESS,
  DETAIL_REGIONAL_FAILURE,
  UPDATE_REGIONAL_REQUEST,
  UPDATE_REGIONAL_SUCCESS,
  UPDATE_REGIONAL_FAILURE,
  DELETE_REGIONAL_REQUEST,
  DELETE_REGIONAL_SUCCESS,
  DELETE_REGIONAL_FAILURE
} from '../../constants/regionals'

const initialState = {
  loadingList: false,
  dataList: [],
  pageable: {},
  loadingDetail: false,
  dataDetail: null,
  loadingCreate: false,
  loadingUpdate: false,
  loadingDelete: false,
  loadingSummary: false,
  dataSummary: [],
  error: null
}

const regionals = (state = initialState, action) => {
  switch (action.type) {
    case LIST_REGIONAL_REQUEST:
      return { ...state, loadingList: true }
    case LIST_REGIONAL_SUCCESS:
      return {
        ...state,
        loadingList: false,
        dataList: action.payload,
        pageable: action.pageable,
        error: null
      }
    case LIST_REGIONAL_FAILURE:
      return { ...state, loadingList: false, error: action.payload, dataList: [] }

    case LIST_REGIONAL_SUMMARY_REQUEST:
      return { ...state, loadingSummary: true }
    case LIST_REGIONAL_SUMMARY_SUCCESS:
      return { ...state, loadingSummary: false, dataSummary: action.payload, error: null }
    case LIST_REGIONAL_SUMMARY_FAILURE:
      return { ...state, loadingSummary: false, error: action.payload, dataSummary: [] }
    case CREATE_REGIONAL_REQUEST:
      return { ...state, loadingCreate: true }
    case CREATE_REGIONAL_SUCCESS:
      return { ...state, loadingCreate: false, error: null }
    case CREATE_REGIONAL_FAILURE:
      return { ...state, loadingCreate: false, error: action.payload }

    case DETAIL_REGIONAL_REQUEST:
      return { ...state, loadingDetail: true, dataDetail: null }
    case DETAIL_REGIONAL_SUCCESS:
      return { ...state, loadingDetail: false, dataDetail: action.payload, error: null }
    case DETAIL_REGIONAL_FAILURE:
      return { ...state, loadingDetail: false, error: action.payload }

    case UPDATE_REGIONAL_REQUEST:
      return { ...state, loadingUpdate: true }
    case UPDATE_REGIONAL_SUCCESS:
      return { ...state, loadingUpdate: false, error: null }
    case UPDATE_REGIONAL_FAILURE:
      return { ...state, loadingUpdate: false, error: action.payload }

    case DELETE_REGIONAL_REQUEST:
      return { ...state, loadingDelete: true }
    case DELETE_REGIONAL_SUCCESS:
      return { ...state, loadingDelete: false, error: null }
    case DELETE_REGIONAL_FAILURE:
      return { ...state, loadingDelete: false, error: action.payload }

    default:
      return state
  }
}

export default regionals
